import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import Logo from "../image/logo.png";
import AptosNormal from "../../utils/Customfonts/Aptos.ttf";
import AptosBold from "../../utils/Customfonts/Aptos-Bold.ttf";

export const inwardRegisterConfig = {
  leftMargin: 15,
  rightMargin: 15,
  tableInset: 3,
  headerImgHeight: 60,
  headerTitleFontSize: 13,
  headerTitleText: "Incoming Register Format",

  footerLeftLabel: "Prepared & Issued By : QM",
  footerLeftSign: "Signature : ",
  footerRightLabel: "Approved By : CMD",
  footerRightSign: "Signature : ",
  footerDocCode: "BFI/7.4/FF/01",

  footerTableFontSize: 9,
  footerRowHeight: 14,
  footerDocCodeHeight: 14,
  footerBottomPad: 4,

  headerFontSize: 7,
  bodyFontSize: 7,
  cellPaddingX: 2,
  cellPaddingY: 2,
  borderLineWidth: 0.6,
  filename: "inwardregister.pdf",
};

const arrayBufferToBase64 = (buffer) => {
  let binary = "";
  const bytes = new Uint8Array(buffer);
  const chunkSize = 8192;
  for (let i = 0; i < bytes.length; i += chunkSize) {
    binary += String.fromCharCode(...bytes.subarray(i, i + chunkSize));
  }
  return btoa(binary);
};

const loadAndAddFont = async (
  doc,
  fontUrl,
  fontFilename,
  fontName,
  fontStyle
) => {
  const res = await fetch(fontUrl);
  const buf = await res.arrayBuffer();
  const b64 = arrayBufferToBase64(buf);
  doc.addFileToVFS(`${fontFilename}.ttf`, b64);
  doc.addFont(`${fontFilename}.ttf`, fontName, fontStyle);
};

const imageToBase64 = (src) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "Anonymous";
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      canvas.getContext("2d").drawImage(img, 0, 0);
      resolve(canvas.toDataURL("image/png"));
    };
    img.onerror = reject;
    img.src = src;
  });

function getFooterMetrics(cfg, pageHeight) {
  const totalFooterH = cfg.footerRowHeight * 3 + cfg.footerDocCodeHeight + cfg.footerBottomPad;
  const footerStartY = pageHeight - totalFooterH;
  const contentBottomY = footerStartY - 2;
  return { totalFooterH, footerStartY, contentBottomY };
}

function getContentTopY(cfg) {
  return cfg.headerImgHeight + 18;
}

function drawHeader(doc, logoBase64, cfg) {
  const pageWidth = doc.internal.pageSize.getWidth();
  doc.addImage(
    logoBase64,
    "PNG",
    cfg.leftMargin + 2,
    4,
    80,
    cfg.headerImgHeight - 12
  );
  doc.setDrawColor(0);
  doc.setLineWidth(0.4);
  doc.rect(
    cfg.leftMargin,
    2,
    pageWidth - cfg.leftMargin - cfg.rightMargin,
    cfg.headerImgHeight
  );
  doc.setFont("AptosBold", "bold");
  doc.setFontSize(cfg.headerTitleFontSize);
  doc.setTextColor(0);
  doc.text(cfg.headerTitleText, pageWidth / 2, cfg.headerImgHeight + 13, {
    align: "center",
  });
  doc.setFont("AptosNormal", "normal");
}

function drawFooter(doc, cfg, pageNumber, totalPagesPlaceholder) {
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const { footerStartY } = getFooterMetrics(cfg, pageHeight);

  const rh = cfg.footerRowHeight;
  const lx = cfg.leftMargin;
  const rx = pageWidth - cfg.rightMargin;
  const usableW = rx - lx;
  const colW = usableW / 2;
  const fs = cfg.footerTableFontSize;

  doc.setDrawColor(0);
  doc.setLineWidth(0.2);

  const rows = [
    [cfg.footerLeftLabel, cfg.footerRightLabel],
    ["Name : ", "Name : "],
    [cfg.footerLeftSign, cfg.footerRightSign],
  ];

  doc.rect(lx, footerStartY, usableW, rh * 3);
  doc.line(lx, footerStartY + rh, rx, footerStartY + rh);
  doc.line(lx, footerStartY + rh * 2, rx, footerStartY + rh * 2);
  doc.line(lx + colW, footerStartY, lx + colW, footerStartY + rh * 3);

  doc.setFont("AptosBold", "bold");
  doc.setFontSize(fs);
  doc.setTextColor(0);

  rows.forEach(([left, right], i) => {
    const textY = footerStartY + rh * i + rh / 2 + fs * 0.35;
    doc.text(left, lx + 5, textY);
    doc.text(right, lx + colW + 5, textY);
  });

  const belowY = footerStartY + rh * 3 + cfg.footerDocCodeHeight - 3;

  doc.text(cfg.footerDocCode, lx + 3, belowY);

  const pageNoText = `Page No: ${String(pageNumber).padStart(2, "0")} of ${String(totalPagesPlaceholder).padStart(2, "0")}`;
  doc.text(pageNoText, rx, belowY, { align: "right" });

  doc.setFont("AptosNormal", "normal");
}

function drawBorderRect(doc, cfg, pageHeight) {
  const pageWidth = doc.internal.pageSize.getWidth();
  const { contentBottomY } = getFooterMetrics(cfg, pageHeight);
  const topY = getContentTopY(cfg);
  doc.setDrawColor(0);
  doc.setLineWidth(cfg.borderLineWidth);
  doc.rect(
    cfg.leftMargin,
    topY,
    pageWidth - cfg.leftMargin - cfg.rightMargin,
    contentBottomY - topY
  );
}

const TABLE_COLUMNS = [
  { header: "Sr.No.", dataKey: "id" },
  { header: "SRF No & Date", dataKey: "SRFNoDate" },
  { header: "DC No", dataKey: "DCNo" },
  { header: "DC Date", dataKey: "DCDate" },
  { header: "ULR Number", dataKey: "ulrNo" },
  { header: "Customer Address", dataKey: "address" },
  { header: "Description", dataKey: "Description" },
  { header: "Make / Model", dataKey: "makemodel" },
  { header: "Range", dataKey: "ranges" },
  { header: "LC", dataKey: "lc" },
  { header: "SL No / ID No", dataKey: "serialNumberducId" },
  { header: "Location", dataKey: "location" },
  { header: "Visual Condition", dataKey: "ConOfDuc" },
  { header: "Calibration Date", dataKey: "dueDate" },
  { header: "Calibrated By", dataKey: "calibratedBy" },
  { header: "Approved By", dataKey: "approvedBy" },
  { header: "Date of Issue", dataKey: "issueDate" },
];

export async function generateInwardRegisterPDF(calData, setLoading, cfg = {}) {
  const config = { ...inwardRegisterConfig, ...cfg };
  setLoading(true);
  try {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "pt",
      format: "a4",
      compress: true,
    });

    await Promise.all([
      loadAndAddFont(doc, AptosNormal, "Aptos", "AptosNormal", "normal"),
      loadAndAddFont(doc, AptosBold, "Aptos-Bold", "AptosBold", "bold"),
    ]);
    doc.setFont("AptosNormal", "normal");

    const logoBase64 = await imageToBase64(Logo);
    const pageHeight = doc.internal.pageSize.getHeight();
    const pageWidth = doc.internal.pageSize.getWidth();

    const { contentBottomY } = getFooterMetrics(config, pageHeight);
    const contentTopY = getContentTopY(config);
    const bottomMargin = pageHeight - contentBottomY;

    const tableLeftMargin = config.leftMargin + config.tableInset;
    const tableRightMargin = config.rightMargin + config.tableInset;

    const head = [TABLE_COLUMNS.map((c) => c.header)];
    const body = calData.map((row, index) =>
      TABLE_COLUMNS.map((col) => {
        if (col.dataKey === "id") return index + 1;
        const val = row[col.dataKey];
        return val != null ? String(val) : "";
      })
    );

    const usableWidth = pageWidth - tableLeftMargin - tableRightMargin;
    const wideColIds = new Set(["address", "Description", "SRFNoDate"]);
    const wideShare = 1.6;
    const normalShare = 1.0;
    const totalShares = TABLE_COLUMNS.reduce(
      (sum, c) => sum + (wideColIds.has(c.dataKey) ? wideShare : normalShare),
      0
    );
    const columnStyles = {};
    TABLE_COLUMNS.forEach((col, i) => {
      const share = wideColIds.has(col.dataKey) ? wideShare : normalShare;
      columnStyles[i] = { cellWidth: (usableWidth * share) / totalShares };
    });

    autoTable(doc, {
      head,
      body,
      startY: contentTopY + 5,
      theme: "grid",
      styles: {
        font: "AptosNormal",
        fontStyle: "normal",
        fontSize: config.bodyFontSize,
        cellPadding: {
          top: config.cellPaddingY,
          bottom: config.cellPaddingY,
          left: config.cellPaddingX,
          right: config.cellPaddingX,
        },
        halign: "center",
        valign: "middle",
        textColor: 0,
        lineWidth: 0.1,
        lineColor: [0, 0, 0],
        overflow: "linebreak",
      },
      headStyles: {
        font: "AptosBold",
        fontStyle: "bold",
        fontSize: config.headerFontSize,
        fillColor: false,
        textColor: 0,
        halign: "center",
        valign: "middle",
        lineWidth: 0.3,
        lineColor: [0, 0, 0],
      },
      columnStyles,
      margin: {
        top: contentTopY + 5,
        left: tableLeftMargin,
        right: tableRightMargin,
        bottom: bottomMargin,
      },
    });
    const totalPages = doc.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      // redraw everything consistently
      drawHeader(doc, logoBase64, config);
      drawBorderRect(doc, config, pageHeight);
      drawFooter(doc, config, i, totalPages);
    }

    doc.save(config.filename);
    setLoading(false);
  } catch (error) {
    console.error("Error generating Inward Register PDF:", error);
    setLoading(false);
  }
}
